'use strict';

var _ = require('lodash');
var Core = require('../core');

module.exports = Resource;

var Util = Core.Util;
var Mixins = Core.Mixins;

function Resource (DS, options) {
  var definition = Util.buildResourceDefinition(options);
  definition.afterUpdate = function(resource, data, cb) {
    cb(null, data);
    var resourceName;
    resource.relationFields.forEach(function(relation) {
      if(data[relation]) {
        if(_.isArray(data[relation])) {
          data[relation].forEach(function(related) {
            if(related.id && related.isDeleted) {
              resourceName = _.find(resource.relationList, 'localField', relation).relation;
              resource.$DS.eject(resourceName, related.id);
            }
          });
        } else {
          var related = data[relation];
          if(data[relation].id && data[relation].isDeleted) {
            resourceName = _.find(resource.relationList, 'localField', relation).relation;
            resource.$DS.eject(resourceName, related.id);
          }
        }
      }
    });
  };

  var resource = DS.defineResource(definition);

  _.extend(resource, {
    $DS: DS,
    $name: options.name,
    $options: options,
    getCollectionLastModified: getCollectionLastModified
  }, Mixins.Base, options.collectionMethods);

  // _.extend(resource, Mixins.Base, options.collectionMethods);

  if (options.group) {
    var Group = Mixins.Group;
    _.extend(resource, Group);
  }

  // extend with sync(ing) methods if necessary
  if (options.syncTriggers && options.syncTriggers.model) {
    var Sync = Mixins.Sync;
    _.extend(resource, Sync);
  }

  // Extend resource with custom replacement for URLs that accept parameters.
  // It uses a different syntax from the `:variable` notation (uses the
  // `{{variable}}` notation instead) because JSData tries to replace it
  // at definition time, not at execution time.
  var origGetEndpoint = resource.getEndpoint;
  resource.getEndpoint = function(id, options) {
    var originalEndpoint = origGetEndpoint.bind(this).call(this, id, options);
    return originalEndpoint.replace(/\{\{(\w+)\}\}/g, function(_, key) {
      var replacement = options[key];
      if(!replacement) {
        throw new Error('No key ' + key + ' present in url');
      }
      return replacement;
    });
  };

  return resource;
}

/**
 * Returns the last time the local collection store was last modified
 * @return {Integer} timestamp
 */
function getCollectionLastModified () {
  // jshint validthis:true
  return this.$DS.store[this.$name].collectionModified;
}



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/Resource.js